import { render, staticRenderFns } from "./specialApply.vue?vue&type=template&id=5281d064"
import script from "./specialApply.vue?vue&type=script&lang=js"
export * from "./specialApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports